import { render, staticRenderFns } from "./zdList.vue?vue&type=template&id=fdb34fc0&scoped=true"
import script from "./zdList.vue?vue&type=script&lang=js"
export * from "./zdList.vue?vue&type=script&lang=js"
import style0 from "./zdList.vue?vue&type=style&index=0&id=fdb34fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb34fc0",
  null
  
)

export default component.exports